enum UpdateForecast {
  UPDATE_FORECAST = 'update-forecast'
}

export default UpdateForecast;
